/*
import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRoute, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { environment } from '../../../environments/environment';
import { AuthService } from '../services/auth.service.';

@Injectable()
export class AuthGuard implements CanActivate {
    rows: any;
    constructor(private router: Router, private authService: AuthService, private route: ActivatedRoute, private cookieService: CookieService) { }
    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        var token = this.authService.getTokenFromSession();
        //token = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsIng1dCI6Ik9JZzAwemgyb2NuNm5kczRBa0E4ZEJneENBQSIsImtpZCI6Ik9JZzAwemgyb2NuNm5kczRBa0E4ZEJneENBQSJ9.eyJhdWQiOiJodHRwczovL2Fncmljb2x0dXJhLXNlcnZpY2UtZGV2LnJlZ2lvbmUuYWJydXp6by5pdCIsImlzcyI6Imh0dHA6Ly9hZGZzLnJlZ2lvbmUuYWJydXp6by5pdC9hZGZzL3NlcnZpY2VzL3RydXN0IiwiaWF0IjoxNjgxOTk2NDQzLCJuYmYiOjE2ODE5OTY0NDMsImV4cCI6MTY4MjAxODA0MywiZmlzY2FsTnVtYmVyIjoiRlJNU01OOTdEMDNGODM5RiIsImZhbWlseV9uYW1lIjoiRm9ybWljb2xhIiwiZ2l2ZW5fbmFtZSI6IlNpbW9uZSIsInNwaWRDb2RlIjoiSU5GQzAwMDE0Mzg1MzUiLCJlbWFpbCI6InNpbW9uZS5mb3JtaWNvbGFAb3V0bG9vay5jb20iLCJkYXRlT2ZCaXJ0aCI6IjE5OTctMDQtMDMiLCJwbGFjZU9mQmlydGgiOiJGODM5Iiwic3ViIjoic2ltb25lLmZvcm1pY29sYUBvdXRsb29rLmNvbSIsIm1vYmlsZVBob25lIjoiKzM5MzQ5MDU3NzExNyIsImFwcHR5cGUiOiJQdWJsaWMiLCJhcHBpZCI6IjZhZjJiYmYyLWRjYzAtNGM4NS04YTEyLWQwYjIxOGQ2ZGFjNCIsImF1dGhtZXRob2QiOiJodHRwczovL3d3dy5zcGlkLmdvdi5pdC9TcGlkTDIiLCJhdXRoX3RpbWUiOiIyMDIzLTA0LTIwVDEzOjE0OjAyLjUyN1oiLCJ2ZXIiOiIxLjAifQ.MPnDqpwanFPeEaKczl5a8weIG4otkI4c4G7FTri6030Ysg-INlPwBXE_89kOt7qvue32rAI_BYPpC869ToGJu-1eHX6vldbj3Z9mhwX8_oEkL6FHU7K7hEmywgj7bbtJnsRt2D1_B4nWtOK9egDfi2jcW2pH3XpfxTnkEEYPU3IW0vbA7Y-I9YfNodZo51ppunO-1OqbDGQBuHz6KNddT8XFu0xjO8_qw5VnrI8bSeh4nXYgMWNzVn-ZcBxM76potvR8Nk73PDjp9GQTtT6G6qm9UMSvot60wkbUdJJhKodlm4srciAx3s78nHwduDAjZDeiu5pD5RWx9fLC4427yg';
        if (token) {
            this.authService.getClaims().subscribe(response => {
                this.rows = response.body['claim'] as Array<any>;
                this.authService.setUserLogin(this.rows);
            }, err => {
                alert(err.error.message);
                this.cookieService.deleteAll()
                document.cookie = 'access_token=;expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
                window.location.href = environment.cisia;
                return false;
            })
            return true;
        }
        else {
            this.cookieService.deleteAll()
            document.cookie = 'access_token=;expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
            window.location.href = environment.cisia;
            return false;
        }
    }
}
*/

import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from "@angular/router";
import { Observable } from "rxjs";
import { AuthService } from "../services/auth.service";

@Injectable({
    providedIn: 'root'
})
export class AuthGuard {
    /**
     *
     * @param router
     * @param authService
     */
    constructor(
        private router: Router,
        private authService: AuthService
    ) { }

    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ):
        | Observable<boolean | UrlTree>
        | Promise<boolean | UrlTree>
        | boolean
        | UrlTree {
        if (this.authService.isAuthenticated()) {
            let activated: Observable<boolean> = new Observable<boolean>(
                (subscriber) => {
                    subscriber.next(true);
                }
            );
            return activated;
        } else {
            this.authService.login();

            return this.authService.authenticationEventObservable;
        }
    }
}
